var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-sidebar"},[_c('chat-list'),(_vm.intelligence.currentChat?._id)?_c('chat',{key:_vm.intelligence?.currentChat?._id}):_vm._e(),(_vm.intelligence.showNewChat)?_c('new-chat'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }